import { useMutation } from '@tanstack/react-query';
import { apiClient } from 'api';
import { useToast } from 'hooks/useToast';

/**
 * Interface for resend email verification payload
 */
export interface ResendEmailVerificationPayload {
  email: string;
}

/**
 * Hook for resending email verification using TanStack React Query
 */
export const useResendEmailVerification = () => {
  const { openToast } = useToast();

  return useMutation({
    mutationFn: async (payload: ResendEmailVerificationPayload) => {
      const response = await apiClient.get<void>('/auth/resend-email-verification/', {
        params: { email: payload.email },
      });
      return response.data;
    },
    onSuccess: (_, variables) => {
      openToast({
        show: true,
        heading: `We have resent the verification mail to ${variables.email}.`,
        text: 'The email may take a few minutes to arrive. You may close this tab',
        type: 'success',
        timeOut: 2000,
      });
    },
    onError: (err: any) => {
      console.error('Resend Email Verification Error:', err); // Log error for debugging
      const errorMessage =
        err?.response?.data?.message ||
        err?.response?.data?.error?.message ||
        'Failed to resend the verification mail, please try again later';
      openToast({
        show: true,
        heading: 'Sorry',
        text: errorMessage,
        type: 'error',
        timeOut: 5000,
      });
    },
  });
};